export default __webpack_public_path__ + "static/LOGO-75458f30f192dcdb369f2929f45139bc.webp";